import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
}

// Логотип СБП — фирменные цвета, монохромный глиф шрифта тут не подходит
export function AppIconSbp({ size = 24 }: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 40 40" fill="none">
      <Path d="M4.00099 8.70629L8.84503 17.3647V22.6461L4.00665 31.2875L4.00099 8.70629Z" fill="#5B57A2" />
      <Path d="M22.5993 14.2156L27.1383 11.4336L36.4277 11.4249L22.5993 19.8963V14.2156Z" fill="#D90751" />
      <Path d="M22.5737 8.65574L22.5994 20.1192L17.744 17.1358V0L22.5741 8.65574H22.5737Z" fill="#FAB718" />
      <Path d="M36.4278 11.4238L27.1381 11.4324L22.5737 8.65574L17.744 0L36.4275 11.4238H36.4278Z" fill="#ED6F26" />
      <Path d="M22.5994 31.3363V25.7745L17.744 22.8478L17.7467 40.0007L22.5994 31.3363Z" fill="#63B22F" />
      <Path
        d="M27.1279 28.5788L8.8447 17.3647L4.00099 8.70629L36.4089 28.5675L27.1275 28.5788H27.1279Z"
        fill="#1487C9"
      />
      <Path d="M17.746 39.9996L22.598 31.3352L27.1257 28.5785L36.4068 28.5672L17.746 39.9996Z" fill="#017F36" />
      <Path d="M4.00493 31.287L17.7827 22.847L13.1507 20.0049L8.84331 22.6456L4.00493 31.287Z" fill="#984995" />
    </Svg>
  )
}
